import React, { Component } from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
import { Link } from 'react-router-dom';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
export function AngelikaSturnPsychotherapiePage() {
  return <div className="min-h-screen bg-white" data-id="element-979">
      <Header data-id="element-980" />
      <main className="w-full pt-[152px]" data-id="element-981">
        <div className="w-full flex justify-center" data-id="element-982">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-983">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3j5qnk2m9cvcrhxkM14wFB/Header-Psychotherapie-Angelika_Sturny.jpg" alt="Psychotherapie Header Bild" className="w-full h-full object-cover" data-id="element-984" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-985"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-986">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-987">
                <div className="max-w-lg text-left" data-id="element-988">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-989">
                    "Verstehen ist der Anfang von Veränderung."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-990">– Carl Rogers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-991">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-992">
            Psychotherapie
          </h1>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-12" data-id="element-993">
            <p data-id="element-994">
              In meiner Praxis begleite ich Menschen in Phasen der Veränderung,
              Überforderung und Neuorientierung. Mein
              systemisch-psychotherapeutischer Ansatz - Zulassung nach dem
              Heilpraktikergesetz für Psychotherapie - eröffnet Raum für neue
              Perspektiven, persönliche Entwicklung und Selbstwirksamkeit. Im
              Zentrum steht die Überzeugung, dass jeder Mensch Teil eines
              größeren Ganzen ist – eingebettet in familiäre Beziehungen,
              berufliche Kontexte und gesellschaftliche Strukturen.
            </p>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg mb-12" data-id="element-995">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-996">
              Ich bin für Sie da, wenn Sie…
            </h2>
            <ul className="space-y-4 text-gray-700" data-id="element-997">
              <li className="flex items-start" data-id="element-998">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-999"></div>
                <span data-id="element-1000">
                  sich emotional belastet, gestresst oder erschöpft fühlen und
                  nach innerer Stabilität suchen.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1001">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1002"></div>
                <span data-id="element-1003">
                  in schwierigen Beziehungskonstellationen stecken – sei es in
                  der Familie, in Freundschaften oder in der Partnerschaft – und
                  neue Perspektiven entwickeln möchten.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1004">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1005"></div>
                <span data-id="element-1006">
                  sich in einer Phase von Trauer, Trennung oder anderen
                  tiefgreifenden Veränderungen befinden und Halt sowie Klarheit
                  brauchen.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1007">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1008"></div>
                <span data-id="element-1009">
                  unter Ängsten, depressiven Verstimmungen oder innerer Unruhe
                  leiden und Wege zur Entlastung und Selbstregulation suchen.
                </span>
              </li>
              <li className="flex items-start" data-id="element-1010">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1011"></div>
                <span data-id="element-1012">
                  den Wunsch verspüren, sich selbst besser zu verstehen, Ihre
                  Persönlichkeit zu entfalten und Ihre Lebensgestaltung bewusst
                  in die Hand zu nehmen.
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg mb-12" data-id="element-1013">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1014">
              Meine therapeutische Haltung ist geprägt von:
            </h2>
            <ul className="space-y-6 text-gray-700" data-id="element-1015">
              <li className="flex items-start" data-id="element-1016">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1017"></div>
                <div data-id="element-1018">
                  <h3 className="font-medium mb-2" data-id="element-1019">Ressourcenorientierung:</h3>
                  <p data-id="element-1020">
                    Wir richten den Blick auf Ihre Stärken, Fähigkeiten und
                    Potenziale. Veränderung beginnt dort, wo Sie Zugang zu Ihren
                    inneren Ressourcen finden.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-1021">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1022"></div>
                <div data-id="element-1023">
                  <h3 className="font-medium mb-2" data-id="element-1024">Kontextsensibilität:</h3>
                  <p data-id="element-1025">
                    Symptome und Konflikte werden nicht isoliert betrachtet,
                    sondern im Zusammenhang mit Ihrem Umfeld – etwa Familie,
                    Partnerschaft, Beruf oder gesellschaftlichen Erwartungen.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-1026">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1027"></div>
                <div data-id="element-1028">
                  <h3 className="font-medium mb-2" data-id="element-1029">Lösungsfokussierung:</h3>
                  <p data-id="element-1030">
                    Gemeinsam entwickeln wir neue Perspektiven und konkrete
                    Schritte zur Veränderung – individuell, machbar und
                    nachhaltig.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-1031">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1032"></div>
                <div data-id="element-1033">
                  <h3 className="font-medium mb-2" data-id="element-1034">
                    Wertschätzung und Augenhöhe:
                  </h3>
                  <p data-id="element-1035">
                    Ihre Erfahrungen und Sichtweisen stehen im Zentrum der
                    therapeutischen Arbeit. Ich begegne Ihnen mit Respekt,
                    Offenheit und einem klaren Blick für Ihre Anliegen.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="mb-12" data-id="element-1036">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1037">
              Ich unterstütze Sie bei…
            </h2>
            <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-1038">
              <AccordionItem value="item-1" title="Lebenskrisen und emotionale Übergänge (z. B. Trennung, Verlust, Veränderungen)" data-id="element-1039">
                <p className="text-gray-600 leading-relaxed" data-id="element-1040">
                  Lebensverändernde Ereignisse wie Trennung, der Verlust eines
                  geliebten Menschen oder berufliche Umbrüche können das innere
                  Gleichgewicht erschüttern. Auch Themen wie Liebeskummer, ein
                  unerfüllter Kinderwunsch oder die Begleitung in
                  Trauerprozessen bringen oft intensive Gefühle mit sich – von
                  Schmerz und Verunsicherung bis hin zu Fragen nach Sinn und
                  Orientierung. In solchen Phasen biete ich Ihnen einen
                  geschützten Raum, in dem Sie Ihre Gedanken und Emotionen
                  sortieren, neue Perspektiven entwickeln und wieder in Kontakt
                  mit Ihren inneren Ressourcen kommen können.
                </p>
              </AccordionItem>
              <AccordionItem value="item-2" title="Psychosomatische Beschwerden und emotionale Erschöpfung" data-id="element-1041">
                <p className="text-gray-600 leading-relaxed" data-id="element-1042">
                  Wenn die Seele leidet, spricht oft auch der Körper.
                  Psychosomatische Beschwerden wie Schlafstörungen, chronische
                  Erschöpfung, innere Unruhe oder körperliche Symptome ohne
                  eindeutige medizinische Ursache können Ausdruck tiefer
                  emotionaler Belastung sein. Auch Gefühle von Ausgebrannt sein,
                  Überforderung oder dauerhafter Anspannung weisen darauf hin,
                  dass das innere Gleichgewicht gestört ist. In meiner Praxis
                  biete ich Ihnen die Möglichkeit diese Signale nachzuspüren und
                  ihre Bedeutung im Kontext Ihres Lebens zu verstehen.
                </p>
              </AccordionItem>
              <AccordionItem value="item-3" title="Selbstwert, Identität und persönliche Entwicklung" data-id="element-1043">
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1044">
                  Fragen nach dem eigenen Selbst, dem persönlichen Wert und der
                  inneren Ausrichtung begleiten viele Menschen – besonders in
                  Zeiten der Veränderung, des Zweifelns oder der
                  Neuorientierung. Vielleicht spüren Sie, dass Sie sich selbst
                  aus dem Blick verloren haben, sich ständig hinterfragen oder
                  sich in bestimmten Rollen nicht mehr wiedererkennen.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1045">
                  In meiner Praxis unterstütze ich Sie dabei, wieder in Kontakt
                  mit Ihrem inneren Kern zu kommen. Wir arbeiten daran, Ihre
                  Selbstwahrnehmung zu stärken, hinderliche Muster zu erkennen
                  und neue Perspektiven auf Ihre persönliche Geschichte zu
                  entwickeln.
                </p>
              </AccordionItem>
              <AccordionItem value="item-4" title="Entscheidungsfindung in komplexen Situationen" data-id="element-1046">
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1047">
                  Manche Entscheidungen lassen sich nicht einfach treffen – sei
                  es, weil mehrere Optionen gleichwertig erscheinen, weil
                  emotionale oder familiäre Bindungen eine Rolle spielen oder
                  weil die Konsequenzen weitreichend sind. Berufliche
                  Veränderungen, familiäre Umbrüche, Trennungen oder persönliche
                  Neuausrichtungen können innere Konflikte auslösen und das
                  Gefühl von Orientierungslosigkeit verstärken.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1048">
                  In meiner Praxis unterstütze ich Sie dabei, Klarheit zu
                  gewinnen und Ihre Entscheidungsprozesse bewusst zu gestalten.
                  Mit einem systemischen Blick betrachten wir nicht nur die
                  Optionen, sondern auch die dahinterliegenden Werte,
                  Erwartungen und Beziehungsmuster, um Ihre Handlungsspielräume
                  zu erweitern und eine tragfähige Entscheidung im Einklang mit
                  Ihrer Lebenssituation zu finden.
                </p>
              </AccordionItem>
              <AccordionItem value="item-5" title="Beziehungskonflikte und familiäre Belastungen" data-id="element-1049">
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1050">
                  Beziehungen – ob in der Partnerschaft, Familie oder im
                  beruflichen Umfeld – sind zentrale Bestandteile unseres
                  Lebens. Sie können Quelle von Unterstützung und Zugehörigkeit
                  sein, aber auch Auslöser für Konflikte, Spannungen und
                  emotionale Belastungen. Wenn Kommunikation stockt, Erwartungen
                  unerfüllt bleiben oder alte Muster immer wieder zu
                  Verletzungen führen, kann das zu einem Gefühl von
                  Hilflosigkeit oder innerer Zerrissenheit führen.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1051">
                  In meiner Praxis biete ich Ihnen die Möglichkeit,
                  Beziehungsthemen in einem geschützten Rahmen zu reflektieren –
                  auch im Einzelsetting. Mit einem systemischen Blick betrachten
                  wir die Dynamiken, die Ihre Beziehungen prägen, und arbeiten
                  daran, neue Perspektiven und Handlungsmöglichkeiten zu
                  entwickeln.
                </p>
              </AccordionItem>
            </Accordion.Root>
          </div>
          {/* Verlinkung zur Info-Seite */}
          <div className="mt-8 text-center" data-id="element-1052">
            <p className="text-gray-600 mb-4" data-id="element-1053">
              Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
              finden Sie unter{' '}
              <Link to="/angelika_sturny/info" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-1054">
                Info
              </Link>
              .
            </p>
            <p className="text-gray-600" data-id="element-1055">
              Appointments are also possible in English. Please contact me via{' '}
              <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-1056">
                email
              </a>{' '}
              for sessions in English!
            </p>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-1057" />
    </div>;
}
// Accordion Item Component
const AccordionItem = ({
  children,
  value,
  title
}: {
  children?: React.ReactNode;
  value: string;
  title: string;
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" data-id="element-1058">
      <Accordion.Header data-id="element-1059">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-1060">
          <span className="text-lg font-medium text-gray-700" data-id="element-1061">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#cda8be] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-1062" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-1063">
        <div className="p-4 bg-white" data-id="element-1064">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};